/**
 * Added to the icon-only buttons of the top bar (menu, online people, cart, bell) so that
 * below 1024px, and on any touch screen (a tablet in landscape is wider than that), each is a
 * 44px square target; with a mouse at 1024px and up they keep their small size.
 */
export const TOPBAR_ICON_BUTTON_TOUCH_TARGET =
  "max-lg:flex max-lg:min-h-11 max-lg:min-w-11 max-lg:items-center max-lg:justify-center [@media(pointer:coarse)]:flex [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:min-w-11 [@media(pointer:coarse)]:items-center [@media(pointer:coarse)]:justify-center";
